// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__ikZlP","label":"CategoryService_label__2UEVz","location":"CategoryService_location__hvb-n"};